<template>
<div class="zixingbianxi-page">
<navBar @goBack="gobackChapter">
<span class="title">字形辨析</span>
</navBar>
<div class="content-box">
<baseChoose :questionType="2"  :zixingbianxi="true"></baseChoose>
</div>
</div>
</template>

<script>
export default {
name: "ziXiangBianXi",
components: {
baseChoose: () => import("../components/baseChoose.vue"),
},
data() {
return {};
},
created() {},
methods: {

},
};
</script>

<style lang="scss" scoped>
.zixingbianxi-page {
width: 100%;
height: 100%;
padding-top: 1.08rem;
.content-box{
height: 100%;
background: #fff;
}
}
</style>